import * as z from "zod";

/** Distinct conversations, not turns. */
const conversationCounts = z.object({
  /** Conversations the agent sent a reply in. */
  replied: z.number(),
  shortfall: z.number(),
  /** A handoff or a caught handoff: the store's staff take over. */
  handedOff: z.number(),
  directToSupport: z.number(),
});

export const getShopperAgentShortfallConversations = {
  name: "getShopperAgentShortfallConversations" as const,
  input: z.object({ start: z.date(), end: z.date() }),
  output: z.object({
    current: conversationCounts,
    /** The window of the same length that ends where this one starts. */
    previous: conversationCounts,
  }),
};
